export enum VehicleStatusEnum {
    None = 0,
    /// <summary>
    /// Статус New становится после статусов Training и Activation
    /// </summary>
    New = 1,
    Pending = 2,
    Approved = 3,
    Rejected = 4,

    /// <summary>
    /// При создании XpressRiderVehicleServiceType сразу же должен быть статус Training
    /// </summary>
    Training = 5,
    /// <summary>
    /// Статус Activation становится после прохождения Training
    /// </summary>
    Activation = 6,

    CheckingVehicleDetails = 7,
    CheckingOrCr = 8,
    CheckingSpaAl = 9,
    CheckingPaCpcTas = 10,
    CheckingPami = 11,
    CheckingCI = 12
}
